import { NotificationsSidebarButtonType } from 'Features/Notifications/NotificationsSidebarButton';
import { ComponentType, ReactNode } from 'react';

export enum SideMenuSection {
  primary = 'primary',
  secondary = 'secondary',
  tertiary = 'tertiary',
  general = 'general',
}

export type SideMenuItem = {
  Icon: ComponentWithAs<'svg', IconProps>;
  path: string;
  section: SideMenuSection;
  title: string;
  component: ReactNode;
  key: string;
  disabledTooltip?: string;
  CustomButton?: ComponentType<NotificationsSidebarButtonType>;
};

export type SideMenuProps = {
  items: SideMenuItem[];
};
